/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck
/** write-controller */
import { http } from '@/services/api/http';
import { RequestOptions } from '@/services/api/types';
import type * as model from './models';

/** write-controller 附件下载 */
export async function downloadAttachmentGet(
  payload: {
    attachId?: number;
    composeId?: string;
    mid?: string;
    msgId: string;
    part?: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<void>({
    url: `/es/api/biz/write/download`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** write-controller 删除草稿邮件 */
export async function deleteDraftEmailGet(
  payload: {
    contactId: string;
    contentId: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultboolean>({
    url: `/es/api/biz/write/draft/delete`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** write-controller 新增&更新草稿邮件 */
export async function editDraftEmailPost(payload: model.IApiDraftEmailReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultstring>({
    url: `/es/api/biz/write/draft/edit`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** write-controller 获取草稿邮件 */
export async function getDraftEmailGet(
  payload: {
    contactId: string;
    contentId: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultCommsEmailDetailResp>({
    url: `/es/api/biz/write/draft/email`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** write-controller 草稿邮件列表 */
export async function getDraftListPost(payload: model.IApiDraftEmailListReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultDraftEmailListResp>({
    url: `/es/api/biz/write/draft/list`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** write-controller editEmail */
export async function editEmailPost(payload: model.IApiDraftEmailReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultboolean>({
    url: `/es/api/biz/write/editEmail`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** write-controller 获取往来邮件卡信息 */
export async function getCommsFlowEmailCardGet(
  payload: {
    msgId: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultCommsFlowEmailDto>({
    url: `/es/api/biz/write/email-card-detail`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** write-controller 邮件详情 */
export async function writeEmailReadPost(payload: model.IApiCommsFlowEmailDetailReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultCommsEmailDetailResp>({
    url: `/es/api/biz/write/email-read`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** write-controller 获取退订连接 */
export async function getUrlGet(options?: RequestOptions) {
  const result = await http.request<model.IApiJsonResultUnsubscribeGetUrlResp>({
    url: `/es/api/biz/write/getUnsubscribeUrl`,
    method: 'get',
    ...options,
  });

  return result.data;
}

/** write-controller renewUrl */
export async function renewUrlPost(
  payload: {
    nosKeys: Array<string>;
  },
  options?: RequestOptions
) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultListUrlResult>({
    url: `/es/api/biz/write/renewURL`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** write-controller 保存邮件设置 */
export async function saveEmailSettingPost(payload: model.IApiEmailSettingReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultboolean>({
    url: `/es/api/biz/write/save/email/setting`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** write-controller 重试手动发信 */
export async function emailSendRetryGet(
  payload: {
    msgId: string;
  },
  options?: RequestOptions
) {
  const params = payload;

  const result = await http.request<model.IApiJsonResultboolean>({
    url: `/es/api/biz/write/send-retry`,
    method: 'get',
    params,
    ...options,
  });

  return result.data;
}

/** write-controller sendEmail */
export async function sendEmailPost(payload: model.IApiSendEmailReq, options?: RequestOptions) {
  const data = payload;

  const result = await http.request<model.IApiJsonResultboolean>({
    url: `/es/api/biz/write/sendEmail`,
    method: 'post',
    data,
    ...options,
  });

  return result.data;
}

/** write-controller 获取签名 */
export async function getSignatureGet(options?: RequestOptions) {
  const result = await http.request<model.IApiJsonResultstring>({
    url: `/es/api/biz/write/signature`,
    method: 'get',
    ...options,
  });

  return result.data;
}

/** write-controller uploadFiles */
export async function uploadFilesPost(
  payload: {
    contentType?: string;
    file: File;
    relatedId: string;
    uploadType?: string;
  },
  options?: RequestOptions
) {
  const params = Object.assign(
    {},
    { contentType: payload.contentType },
    { relatedId: payload.relatedId },
    { uploadType: payload.uploadType }
  );
  const data: any = new FormData();
  data.append('file', payload.file);

  const result = await http.request<model.IApiJsonResultUrlResult>({
    url: `/es/api/biz/write/uploadFile`,
    method: 'post',
    params,
    data,
    ...options,
  });

  return result.data;
}
